<div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto " >
    <div class="card card0 border-0 ">
        <div class="row d-flex">
            <div class="col-lg-6">
                <div class="card1 pb-5">
                    <!-- <div class="row"> <img src="https://i.imgur.com/CXQmsmF.png" class="logo"> </div> -->
                    <div class="row px-3 justify-content-center mt-4 mb-5 border-line"> <img src="assets/board_logo.png" class="image"> 
                        <h2 style="text-align: center;">Goa Board of Secondary and
                            Higher Secondary Education
                            </h2>
                            <h4>Alto Betim -Goa 403 521</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card2 card card0">
                    <div class="card-header">
                     <h4>Login </h4>
                    </div>
                    <div class="card-body">
                        <form role="form" [formGroup]="formlogin" (submit)="submitlogin()">
                            <div class="form-group">
                              <label for="exampleInputEmail1">Username</label>
                              <input type="text" class="form-control" formControlName="username" #username aria-describedby="emailHelp" placeholder="Enter Username">
                              <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
                            </div>
                            <div class="form-group">
                              <label for="exampleInputPassword1">Password</label>
                              <input type="password" class="form-control" formControlName="password" #password placeholder="Enter Password">
                            </div>
                            <div class="form-group" >
                                <label for="exampleInputPassword1">Captcha</label>
                                <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" [size]="size"
                                [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha" required >
                                </ngx-recaptcha2 >  
                            </div>
                            
                            <div class="form-group" style="text-align: center;">
                                <button type="submit" class="btn btn-primary">Submit</button>
                            </div>
                           
                          </form>
                    </div>
                  </div>
            </div>
        </div>
        <!-- <div class="bg-blue py-4" style="background-color: rgba(85, 83, 83, 0.2);font-size: 10px;">
            <div class="row px-3" > <small class="ml-4 ml-sm-5 mb-2"><a class="text-dark">©This is the official website of Goa Board of Secondary and Higher Secondary Education
                Alto Betim - Goa 403 521, India. All Rights Reserved.</a><br>
                Developed By
                <a class="text-dark" href="http://edhaasdigisoft.com/" ><b>Edhaas DigiSoft Private Limited</b></a></small>
                
            </div>
        </div> -->
    </div>
</div>
